<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-list-ol"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Name"><FormStaticLabel>{{item.name}}</FormStaticLabel></FormRow>
      <FormRow label="Prefix"><FormInputText placeholder="Prefix" v-model="item.prefix" field="prefix" /></FormRow>
      <FormRow label="Padding"><FormInputText type="number" placeholder="Padding" v-model="item.paddingCount" field="paddingCount" /></FormRow>
      <FormRow label="Next Number"><FormInputText type="number" placeholder="Next Number" v-model="item.nextNumber" field="nextNumber" /></FormRow>
      <FormRow label="Preview"><FormStaticLabel>{{displayPreview()}}</FormStaticLabel></FormRow>

      <NotificationBar type="warning" v-if="item.nextNumber != '' && item.nextNumber < initialNumber">
        <NotificationBarTitle>Warning</NotificationBarTitle>
        <NotificationBarItem>Setting the next number below its current value ({{initialNumber}}) can result in duplicate sequence numbers assigned</NotificationBarItem>
      </NotificationBar>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: "DescriptorLookupEditDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    isCreateMode: Boolean
  },
  data() {
    return {
      id: null,
      item: {},
      initialNumber: 0,
      dialogForm: {},
      submitting: false,
    }
  },
  mounted() {
  },
  computed: {
    title() {
      return 'Edit Sequence'
    },
    submitTitle() {
      return 'Update'
    },
  },
  methods: {
    show(item) {
      // Reset form
      this.item = { }
      this.id = 0
      this.dialogForm = {}
      this.submitting = false

      if(item != null) {
        this.item = _.cloneDeep(item)
        this.id = item.id
        this.initialNumber = this.item.nextNumber
      }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = _.cloneDeep(this.$data.item)

      this.$apiService.adminService.updateSequenceConfig(this.item.code, updateData)
      .then(() => {
        this.submitting = false
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.submitting = false
        this.$data.dialogForm = this.processFormResponse(err)
      })
    },
    displayPreview() {
      if(this.item.nextNumber == '' || this.item.nextNumber == null)
        return ''
      return this.item.prefix + this.item.nextNumber.toString().padStart(parseInt(this.item.paddingCount), '0')
    }
  }
}
</script>